const CURRENCY_SYMBOL = /^[^\d.,-]+/;
const THOUSAND_SEPARATED_NUMBER = /^\d{1,3}(,\d{3})*$/;
const VALID_CURRENCY_NUMBER = /^-?\d{1,3}(,\d{3})*(\.\d+)?$|^-?\d+(\.\d+)?$/;
const INVALID_NEGATIVE_CURRENCY_FORMAT = /^-\D|\D-/;
const _NaN = 'NaN';

export function currencyInvert(value: string): string {
  if (!value) return _NaN;

  const withoutSymbol = value.replace(CURRENCY_SYMBOL, '').trim();

  if (INVALID_NEGATIVE_CURRENCY_FORMAT.test(value) || !VALID_CURRENCY_NUMBER.test(withoutSymbol)) {
    return _NaN;
  }

  const hasComma = withoutSymbol.includes(',');
  const hasDot = withoutSymbol.includes('.');

  let normalized = withoutSymbol;

  if (hasComma && hasDot) {
    const lastComma = withoutSymbol.lastIndexOf(',');
    const lastDot = withoutSymbol.lastIndexOf('.');

    if (lastDot > lastComma) {
      normalized = withoutSymbol.replace(/,/g, '');
    } else {
      return _NaN;
    }
  }

  if (hasComma && !hasDot) {
    if (THOUSAND_SEPARATED_NUMBER.test(withoutSymbol)) {
      normalized = withoutSymbol.replace(/,/g, '');
    } else {
      return _NaN;
    }
  }

  const number = parseFloat(normalized);

  const hadCurrencySymbol = value !== withoutSymbol;
  if (number < 0 && hadCurrencySymbol) {
    return _NaN;
  }

  return isNaN(number) ? _NaN : (number * 100).toFixed(0);
}
